import clsx from 'clsx';
import { styles as checkboxStyles } from '../Checkbox/styles';

export const styles = {
  container: 'tw-w-full tw-min-h-0 tw-flex tw-flex-col tw-rounded tw-bg-white tw-shadow-md tw-border tw-border-neutral-200',
  toolbar: 'tw-flex tw-items-center tw-gap-4 tw-px-6 tw-py-3 tw-border-b tw-border-neutral-200',
  searchWrapper: 'tw-max-w-[300px] tw-min-w-[180px] tw-flex-1',
  headerRow: 'tw-bg-neutral-50 tw-border-b tw-border-neutral-200',
  stickyHeader: 'tw-sticky tw-top-0 tw-z-10 tw-bg-neutral-50',
  headerCell: 'tw-px-6 tw-py-4 tw-text-xs tw-font-bold tw-text-neutral-700 tw-uppercase tw-tracking-wider tw-bg-neutral-50',
  sortableHeader:
    'tw-flex tw-w-full tw-max-w-full tw-items-center tw-gap-1.5 tw-border-0 tw-bg-transparent tw-p-0 tw-font-inherit tw-text-inherit tw-tracking-inherit tw-uppercase tw-cursor-pointer tw-transition-colors hover:tw-text-primary-600 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-primary-500 focus-visible:tw-ring-offset-2',
  sortIcon: 'tw-h-3 tw-w-3 tw-shrink-0 tw-text-neutral-400',
  sortIconActive: 'tw-text-primary-600',
  checkboxCell: 'tw-w-14 tw-px-6 tw-py-4',
  checkbox: checkboxStyles.checkbox,
  bodyCell: 'tw-px-6 tw-py-4 tw-text-sm tw-text-neutral-800',
  errorMessage: 'tw-p-4 tw-text-danger-500 tw-text-center',
  emptyState: 'tw-px-6 tw-py-16 tw-text-center tw-text-neutral-500',
  loadingContainer: 'tw-flex tw-items-center tw-justify-center tw-gap-3 tw-text-primary-600',
};

export const getRowStyles = (isClickable: boolean, isSelected: boolean) =>
  clsx(
    'tw-transition-colors tw-duration-150',
    'tw-border-b tw-border-neutral-100',
    isClickable && 'tw-cursor-pointer hover:tw-bg-primary-50',
    isSelected && 'tw-bg-primary-100 tw-border-l-4 tw-border-l-primary-500'
  );

export const getAlignClass = (align?: 'left' | 'center' | 'right') => {
  switch (align) {
    case 'center':
      return 'tw-text-center';
    case 'right':
      return 'tw-text-right';
    default:
      return 'tw-text-left';
  }
};

export const getSortableJustifyClass = (align?: 'left' | 'center' | 'right') => {
  switch (align) {
    case 'center':
      return 'tw-justify-center';
    case 'right':
      return 'tw-justify-end';
    default:
      return 'tw-justify-start';
  }
};
